import { Injectable } from '@angular/core';
import { Energietraeger } from '../../domain/model/energietraeger';

@Injectable({
    providedIn: 'root',
})
export class AnlagentypColorService {

    public static readonly DEFAULT_COLOR = 'iridescent-indigo-bright';
    public static readonly COLOR_OTHERTYPES = 'pulsing-purple-bright';
    public static readonly COLOR_WATER = 'iridescent-indigo-bright';
    public static readonly COLOR_WIND = 'blazing-blue-bright';
    public static readonly COLOR_PHOTOVOLTAIC = 'mellow-yellow-bright';
    public static readonly COLOR_BIO = 'galvanic-green-bright';

    public static readonly ENERGIETRAEGER_TO_COLOR_NAME: Map<Energietraeger, string> = new Map([
        // other types
        [
            Energietraeger.SONSTIGES,
            AnlagentypColorService.COLOR_OTHERTYPES,
        ],

        // water
        [
            Energietraeger.PUMPSPEICHER,
            AnlagentypColorService.COLOR_WATER,
        ],
        [
            Energietraeger.LAUFWASSER,
            AnlagentypColorService.COLOR_WATER,
        ],
        [
            Energietraeger.SPEICHERWASSER,
            AnlagentypColorService.COLOR_WATER,
        ],

        // bio and geo
        [
            Energietraeger.GASE,
            AnlagentypColorService.COLOR_BIO,
        ],
        [
            Energietraeger.BIOMASSE,
            AnlagentypColorService.COLOR_BIO,
        ],
        [
            Energietraeger.GEOTHERMIE,
            AnlagentypColorService.COLOR_BIO,
        ],
        [
            Energietraeger.GASE_ERDGAS,
            AnlagentypColorService.COLOR_BIO,
        ],

        // wind
        [
            Energietraeger.WINDENERGIE_OFFSHORE,
            AnlagentypColorService.COLOR_WIND,
        ],
        [
            Energietraeger.WINDENERGIE_ONSHORE,
            AnlagentypColorService.COLOR_WIND,
        ],

        // Photovoltaic
        [
            Energietraeger.SOLAR,
            AnlagentypColorService.COLOR_PHOTOVOLTAIC,
        ],
    ]);

    public getColorNameForEnergietraeger(energietraeger: Energietraeger): string {
        if (energietraeger) {
            const colorName = AnlagentypColorService.ENERGIETRAEGER_TO_COLOR_NAME.get(energietraeger);
            if (colorName) {
                return colorName;
            }
        }
        return AnlagentypColorService.DEFAULT_COLOR;
    }

}
